export const CONFIG = {
  wsBaseUrl: 'ws://gw.nsdt.com', // webSocket baseUrl
}

// 域名搜索 - 交易状态
export const TRADE_STATUS = ["正在出售", "正在push", "正在交易", "正在转出"]; // 交易状态
export const REAL_NAME_STATUS = ["未认证", "认证中", "认证成功", "认证失败"]; // 实名状态
export const BATCH_TYPE_LIST = [
  {
    value: 1,
    label: "批量续费",
  },
  {
    value: 2,
    label: "设置自动续费",
  },
  {
    value: 3,
    label: "取消自动续费",
  },
  {
    value: 4,
    label: "设置DNS",
  },
  {
    value: 5,
    label: "开启隐私保护",
  },
  {
    value: 6,
    label: "关闭隐私保护",
  },
  {
    value: 7,
    label: "批量PUSH",
  },
]; // 我的域名 - 批量操作类型

// 公司证件类型列表
export const COMPANY_TYPE_LIST = [
  {
    value: 0,
    label: '企业组织机构代码证'
  },
  {
    value: 1,
    label: '营业执照'
  },
  {
    value: 2,
    label: '统一社会信用代码证'
  },
  {
    value: 3,
    label: '北京市外国驻华使馆人员子女学校办学许可证'
  },
  {
    value: 4,
    label: '事业单位法人证书'
  },
  {
    value: 5,
    label: '社会团体法人登记证书'
  },
  {
    value: 6,
    label: '民办非企业单位登记证书'
  },
  {
    value: 7,
    label: '律师事务所执业许可证'
  },
  {
    value: 8,
    label: '司法鉴定许可证'
  },
  {
    value: 9,
    label: '宗教活动场所登记证'
  },
  {
    value: 10,
    label: '基金会法人登记证书'
  },
  {
    value: 11,
    label: '部队代号'
  },
  {
    value: 12,
    label: '军队单位对外有偿服务许可证'
  },
  {
    value: 13,
    label: '外国企业常驻代表机构登记证'
  },
  {
    value: 14,
    label: '外国在华文化中心登记证'
  },
  {
    value: 15,
    label: '外国政府旅游部门常驻代表机构批准登记证'
  },
  {
    value: 16,
    label: '境外机构证件'
  },
  {
    value: 17,
    label: '社会服务机构登记证书'
  },
  {
    value: 18,
    label: '民办学校办学许可证'
  },
  {
    value: 19,
    label: '医疗机构执业许可证'
  }
]

// 订单状态
export const ORDER_STATUS = [
  {
    name: "全部",
    value: -1,
  },
  {
    name: "待支付",
    value: 0,
  },
  {
    name: "已取消",
    value: 2,
  },
  {
    name: "已过期",
    value: 3,
  },
  {
    name: "交易成功",
    value: 1,
  }
]

export const MAP_ORDER_STATUS = {
  '0': "待支付",
  '1': "已支付",
  '2': "已取消",
  '3': "已过期",
}


// 发票状态类型
export const RECEIPT_STATUS_TYPE = [
  {
    name: '未处理',
    value: 0
  },
  {
    name: '待审核',
    value: 1
  },
  {
    name: '待开票',
    value: 2
  },
  {
    name: '已开票',
    value: 3
  },
  {
    name: '待寄出',
    value: 4
  },
  {
    name: '已寄出',
    value: 5
  },
  {
    name: '审核未通过',
    value: 6
  },
  {
    name: '用户取消',
    value: 7
  }
]

export const MAP_RECEIPT_STATUS = {
  0: '未处理',
  1: '待审核',
  2: '待开票',
  3: '已开票',
  4: '待寄出',
  5: '已寄出',
  6: '审核未通过',
  7: '用户取消',
}


export const DOMAIN_OUT_TIPS = [
  "域名注册满60天后可以办理转移注册商。",
  "cn/top/wang等域名距离到期前16天以上可以办理转移，域名到期时间不足16天不能办理转出。",
  "国际域名在续费后60天内转入到新注册商，可能续费不会增加一年，建议等待续费满60天后再办理转移。转移密码有效时间为5天，请在有效期内操作转移，如过期不操作自动视为放弃转移。",
  "设置了隐私保护的域名，获取转移密码前要先取消隐私保护。",
  "国内部分注册商(万网、新网等)及其代理不能在线过户域名，转入后域名信息不能自动变更或通过在线过户变更，请谨慎操作。",
  "获取转移密码到邮箱里，可能会由于网络延迟或邮件过滤设置等原因，导致邮件延迟或收不到，建议可以垃圾邮件中查看下，或更改邮件过滤设置。",
  "若有任何疑问，请联系域名专员协助解决：联系电话:400-082-3818 邮箱: official@nsdt.com",
];
